module.exports = __webpack_public_path__ + "static/img/number3.a76732a5.png";